export enum PermitType {
	Unlimited = 'Unlimited',
	Limited = 'Limited',
	NoPermit = 'NoPermit',
}
